import {Modal} from "antd";
import React, {ReactNode} from "react";
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import {bindActionCreators, Dispatch} from "redux";
import {setModalVisibility} from "../../../core/app/setModalVisibility/actions";
import {ModalType} from "../../../core/models/custom/enums/modalType";
import {ModalVisibilityPayload} from "../../../core/models/custom/modalVisibility.payload";
import {MeDto} from "../../../core/models/dtos/me.dto";
import {OfferDto} from "../../../core/models/dtos/offer.dto";
import ContentKeys from "../../../core/utilities/contentKeys";
import {Images} from "../../../core/utilities/images";
import {IStore} from "../../../core/utilities/reducers";
import {router} from "../../../core/utilities/router";
import {UI} from "../../../core/utilities/ui";
import ContentKey from "../../ContentKey/ContentKey";
import ModalCancelButton from "../Common/ModalCancelButton/ModalCancelButton";
import ModalHeader from "../Common/ModalHeader/ModalHeader";
import Offers from "../Common/Offers/Offers";
import Reward from "../Common/Reward/Reward";
import "./DecisionModal.scss";

interface IProps {
  me?: MeDto;
  modalVisibilityData: ModalType[];
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
  callback: (modal: ModalType, offer: OfferDto) => void;
}

const DecisionModal = (props: IProps) => {
  const navigate = useNavigate();
  const modal = ModalType.DECISION;
  
  const handleModal = (offer: OfferDto): void => {
    props.callback(modal, offer);
  }
  
  const handleModalClose = (): void => {
    props.setModalVisibility({modal, isVisible: false});
    navigate(router.HOME);
  }
  
  const renderOffers = (): ReactNode => {
    return (
      <Offers
        offers={props.me?.offers ?? []}
        modal={modal}
        callbackSelection={offer => handleModal(offer)}
      />
    );
  }
  
  return (
    <Modal
      className="decision-modal"
      maskStyle={UI.modalMaskStyle()}
      open
      closable={false}
      footer={false}
      centered
      destroyOnClose
      style={UI.getStyleModalOffer(props.modalVisibilityData)}
    >
      <ModalHeader
        className="decision-modal"
        text={<ContentKey contentKey={ContentKeys.DESICION_HEADER}/>}
        icon={<img className="icon" src={Images.popup_header_icon_decision} alt="icon"/>}
      />
      
      <div className="body">
        
        <Reward rewardKey={ContentKeys.getRewardKey(modal)}/>
        
        <ContentKey
          className="text text-medium"
          contentKey={ContentKeys.DESICION_TITLE}
        />
        
        {renderOffers()}
      </div>
      <ModalCancelButton callback={() => handleModalClose()}/>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setModalVisibility,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
    modalVisibilityData: store.setModalVisibility.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DecisionModal);
